import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const STEP_LABELS = [
  "Starting Point",
  "Template Structure",
  "Template Preferences",
  "Preview",
  "Name & Save",
];

export default function WizardStepIndicator({
  currentStep,
  totalSteps = 5,
}) {
  return (
    <div className="flex items-center gap-sm w-full justify-center">
      {Array.from({ length: totalSteps }, (_, i) => {
        const stepNumber = i + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;

        return (
          <div key={stepNumber} className="flex items-center gap-sm">
            <div className="flex items-center gap-xs">
              <div
                className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold shrink-0 transition-colors ${
                  isCompleted
                    ? "bg-brand text-white"
                    : isCurrent
                      ? "bg-brand text-white"
                      : "bg-secondary text-secondary"
                }`}
              >
                {isCompleted ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="text-xs"
                  />
                ) : (
                  stepNumber
                )}
              </div>
              <span
                className={`text-xs font-medium truncate hidden sm:block ${
                  isCurrent ? "text-primary" : "text-secondary"
                }`}
              >
                {STEP_LABELS[i]}
              </span>
            </div>
            {stepNumber < totalSteps && (
              <div
                className={`flex-1 h-px ${
                  isCompleted ? "bg-brand" : "bg-secondary"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
